import { render, staticRenderFns } from "./addProductDialogSteps.vue?vue&type=template&id=55a8f32d&scoped=true&"
import script from "./addProductDialogSteps.vue?vue&type=script&lang=js&"
export * from "./addProductDialogSteps.vue?vue&type=script&lang=js&"
import style0 from "./addProductDialogSteps.vue?vue&type=style&index=0&id=55a8f32d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8f32d",
  null
  
)

export default component.exports